import { useCallback } from 'react';
import { MBView } from '@shared/components/MBView';
import { MBModal } from '@shared/components/modal';
import { useToast } from '@shared/components/toast';
import { MBGIFSearch } from '@shared/scenes/gifs/containers/search';
import { useDispatch, useSelector } from '@shared/store';
import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { Styles } from '../components/styles';
import * as Actions from '../store/actions';
import { MAX_CHAT_ATTACHMENTS } from '../store/reducer';

interface Props {
  draftId: string;
}

export function MBChatInputGIFModal({ draftId }: Props) {
  const dispatch = useDispatch();
  const toast = useToast();
  const visible = useSelector(state => !!state.chatInput.isGIFModalVisibleFromDraftId[draftId]);
  const isDesktop = useIsDesktop();
  const close = useCallback(() => dispatch(Actions.hideGIFModal(draftId)), [dispatch, draftId]);

  const onLimitExceeded = useCallback(() => {
    toast.show({
      style: 'warning',
      message: i18n('chat.input.attachmentLimit.gif', { max: MAX_CHAT_ATTACHMENTS }),
      duration: 4000,
    });
  }, [toast]);

  const select = useCallback(
    (gif: MBGIF) => dispatch(Actions.selectGIF(gif, draftId, onLimitExceeded)),
    [dispatch, draftId, onLimitExceeded],
  );

  return (
    <MBModal
      visible={visible}
      animationType="slide"
      title={i18n('gif.gifSearch')}
      onClose={close}
      padding={0}
    >
      <MBView style={isDesktop ? Styles.gifModalDesktop : Styles.gifModal}>
        <MBGIFSearch onSelect={select} />
      </MBView>
    </MBModal>
  );
}
